module.exports = __webpack_public_path__ + "img/zheng.d2252511.png";